import { getCanvasCoord, subtractCoordinates } from '../../utils/utils.js'
import { updateHistoryStackAfterSelect } from '../../utils/undoRedoUtils.js'

export const handleSelectUp = (e, state) => {
  const {
    boardId,
    ///////
    paths,
    scope,
    translate,
    selectionRect,
    setSelectionRect,
    selectionRectPathKeys,
    setSelectionRectPathKeys,
    setLockedCheckKey,
    // dragging
    isDragging,
    setIsDragging,
    draggingStartPos,
    // move
    isSelectedMovingActive,
    setIsSelectedMovingActive,
    // resize
    isResizeActive,
    setIsResizeActive,
    // extra
    clientCoord,
    selectCoordinateAtPointerDown,
    historyStack,
    setHistoryStack,
    // 동시편집
    ydocRef,
    triggerUpdatePath,
    pathsAtPointerDown,
  } = state

  // ============================================================================
  // [1] 선택 박스를 드래그로 새로 생성한 경우
  // ============================================================================
  if (isDragging) {
    setIsDragging(false)

    // 시작 위치와 현재 위치 차이 측정
    const gapBetweenPointerDownAndUp = subtractCoordinates(
      {
        x: draggingStartPos.current.x,
        y: draggingStartPos.current.y,
      },
      getCanvasCoord(clientCoord, translate, scope)
    )

    // --- 드래그가 아닌 단순 클릭 (20px 이하)
    if (
      gapBetweenPointerDownAndUp.x >= -20 &&
      gapBetweenPointerDownAndUp.x < 20 &&
      gapBetweenPointerDownAndUp.y >= -20 &&
      gapBetweenPointerDownAndUp.y < 20
    ) {
      // 아무것도 선택되지 않았고, path를 클릭했다면
      if (selectionRectPathKeys.length === 0 && e.target.id.includes('path')) {
        let selectedKey = e.target.id.substring(e.target.id.indexOf('-') + 1)
        // unlock 상태인 경우 selectionRect 활성화
        if (!paths[selectedKey].isLocked) {
          setSelectionRectPathKeys([selectedKey])
        }
        // 이미지 잠금상태 키 설정
        setLockedCheckKey(selectedKey)
      } else {
        // 이미지 잠금상태 키 설정 해제
        setLockedCheckKey('')
      }
    }
    // --- 실제 드래그 (20px 이상 이동)
    else {
      // 이미지 잠금상태 키 설정 해제
      setLockedCheckKey('')
    }
  }

  // ============================================================================
  // [2] 선택된 path를 이동 중이었을 경우
  // ============================================================================
  if (isSelectedMovingActive) {
    setIsSelectedMovingActive(false)

    // PointerDown과 PointerUp에서의 포인터 위치 차이가 근소할 경우 이동 기능 비활성화
    const gapBetweenPointerDownAndUp = subtractCoordinates(
      {
        x: selectCoordinateAtPointerDown.current.x,
        y: selectCoordinateAtPointerDown.current.y,
      },
      getCanvasCoord(clientCoord, translate, scope)
    )

    // --- 거의 움직이지 않았으면 → 이동 취소 처리
    if (
      gapBetweenPointerDownAndUp.x >= -20 &&
      gapBetweenPointerDownAndUp.x < 20 &&
      gapBetweenPointerDownAndUp.y >= -20 &&
      gapBetweenPointerDownAndUp.y < 20
    ) {
      setSelectionRect({ top: 0, left: 0, width: 0, height: 0 })
      setSelectionRectPathKeys([])
      setLockedCheckKey('')

      // historyStack 길이 조정
      historyStack[boardId].stack.length = historyStack[boardId].pointer + 1
    }
    // --- 실제로 이동한 경우 → history 업데이트
    else {
      // ⭐️ 250930 이우주: move가 아닌 up에서 path 이동 동기화 임시 처리
      let delta = subtractCoordinates(
        getCanvasCoord(clientCoord, translate, scope),
        selectCoordinateAtPointerDown.current
      )

      ydocRef.current.transact(() => {
        for (let pathKey of selectionRectPathKeys) {
          paths[pathKey].x = pathsAtPointerDown.current[pathKey].x + delta.x
          paths[pathKey].y = pathsAtPointerDown.current[pathKey].y + delta.y

          triggerUpdatePath(
            pathKey,
            {
              x: paths[pathKey].x,
              y: paths[pathKey].y,
            },
            'no-op'
          )
        }
      })

      updateHistoryStackAfterSelect({ boardId, paths, setHistoryStack })
    }
  }

  // ============================================================================
  // [3] 선택된 path를 리사이즈 중이었을 경우
  // ============================================================================
  if (isResizeActive) {
    // 리사이즈 완료 후 선택 박스 재계산
    if (selectionRectPathKeys.length) {
      const sgSelection = {
        top: Infinity,
        left: Infinity,
        right: -Infinity,
        bottom: -Infinity,
      }

      ydocRef.current.transact(() => {
        for (let key of selectionRectPathKeys) {
          sgSelection.top = Math.min(paths[key].y + paths[key].minY, sgSelection.top)
          sgSelection.left = Math.min(paths[key].x + paths[key].minX, sgSelection.left)
          sgSelection.right = Math.max(paths[key].x + paths[key].maxX, sgSelection.right)
          sgSelection.bottom = Math.max(paths[key].y + paths[key].maxY, sgSelection.bottom)

          triggerUpdatePath(key, paths[key], 'replace')
        }
      })

      selectionRect.top = sgSelection.top
      selectionRect.left = sgSelection.left
      selectionRect.width = sgSelection.right - sgSelection.left
      selectionRect.height = sgSelection.bottom - sgSelection.top
      setSelectionRect({ ...selectionRect })
    }

    setIsResizeActive(false)
    // 리사이즈 반영 후 history 스택 업데이트
    updateHistoryStackAfterSelect({ boardId, paths, setHistoryStack })
  }
}
